export var TITLE = 'Ollama';
export var COMBINE_TEXT_MULTIPLE = 0.6;
export var COMBINE_SPACE_MULTIPLE = 0.1;
export var COLOR_PRIMARY = '#fff';

// Avatar constants
export var AVATAR_BACKGROUND = COLOR_PRIMARY;
export var AVATAR_COLOR = '#000';
export var AVATAR_ICON_MULTIPLE = 0.75;